<template>
    <div class="btn-toolbar">
        <b-button-group>
            <b-dropdown
                    id="export"
                    class="txt-btn dropdown-btn font-type height-small"
                    variant="outline-primary"
            >
                <template v-slot:button-content>
                    <font-awesome-icon :icon="['fas', 'upload']" /> Exporter
                </template>
                <b-dropdown-item
                        :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
                        @click="handleExport"
                >Export Tableau</b-dropdown-item
                >
                <b-dropdown-item
                        :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
                        @click="handleExportDescription"
                >Export Description</b-dropdown-item
                >
            </b-dropdown>
        </b-button-group>
        <b-button-group>
            <b-button
                    v-if="!this.saving()"
                    @click.prevent="saveChanges()"
                    class="txt-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'save']" /> Sauvegarder
            </b-button>
            <b-button v-else class="txt-btn" variant="primary">
                <b-spinner small type="grow"></b-spinner>En attente...
            </b-button>
        </b-button-group>
        <div class="divider"></div>
        <b-button-group>
            <b-button
                    @click.prevent="undoClick()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'undo']" />
            </b-button>
            <b-button
                    @click.prevent="redoClick()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'redo']" />
            </b-button>
            <b-button
                    @click.prevent="formatClone()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'paint-roller']" />
            </b-button>
        </b-button-group>
        <b-button-group>
            <b-dropdown
                    :style="[
          {
            fontFamily: this.getSelectedFontFamily().family,
            fontSize: '12px',
            textOverflow: 'ellipsis'
          }
        ]"
                    variant="outline-primary"
                    class="font-type heighted"
            >
                <template slot="button-content">
                    {{ this.getSelectedFontFamily().name | truncate(10) }}
                </template>
                <b-dropdown-item
                        v-for="fm in this.fontFamily"
                        :key="fm.name"
                        :active="fm.state"
                        :style="[{ fontFamily: fm.family, fontSize: '11px' }]"
                        @click.prevent="fontFamilyClick(fm.family)"
                >{{ fm.name }}</b-dropdown-item
                >
            </b-dropdown>
            <b-dropdown
                    :text="this.getSelectedFontSize()"
                    variant="outline-primary"
                    class="font-size"
            >
                <b-dropdown-item
                        v-for="size in this.fontSize"
                        :key="size.value"
                        :active="size.state"
                        :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
                        @click.prevent="fontSizeSelected(size.value)"
                >{{ size.value }}</b-dropdown-item
                >
            </b-dropdown>
        </b-button-group>
        <b-button-group>
            <b-button
                    :pressed="this.fontWeight.state"
                    @click.prevent="fontWeightClick()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'bold']" />
            </b-button>

            <b-button
                    :pressed="this.textDecoration.state"
                    @click.prevent="fontUnderlineClick()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'underline']" />
            </b-button>

            <b-button
                    :pressed="this.fontStyle.state"
                    @click.prevent="fontStyleClick()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'italic']" />
            </b-button>
        </b-button-group>
        <!-- <b-button-group>
          <b-button
            class="icon-btn"
            @click.prevent="exposantClick"
            variant="outline-primary"
          >
            <font-awesome-icon :icon="['fas', 'superscript']" />
          </b-button>
          <b-button
            class="icon-btn"
            @click.prevent="indiceClick"
            variant="outline-primary"
          >
            <font-awesome-icon :icon="['fas', 'subscript']" />
          </b-button>
        </b-button-group> -->
        <b-button-group>
            <b-dropdown
                    id="font-color-picker"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <template slot="button-content">
                    <font-awesome-icon v-bind:style="{ color }" :icon="['fas', 'font']" />
                </template>
                <div class="color-picker">
                    <color-picker
                            v-if="showFontColorPicker"
                            theme="light"
                            :sucker-hide="true"
                            :color="color"
                            :colors-default="societyColors"
                            :colors-history-key="colorsHistoryKey"
                            @changeColor="changeColor"
                    />
                </div>
            </b-dropdown>
            <b-dropdown
                    id="background-color-picker"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <template slot="button-content">
                    <font-awesome-icon
                            :icon="['fas', 'fill-drip']"
                    />
                </template>
                <div class="color-picker">
                    <color-picker
                            theme="light"
                            v-if="showBackgroundColorPicker"
                            :sucker-hide="true"
                            :color="backgroundColor"
                            :colors-default="societyColors"
                            :colors-history-key="colorsHistoryKey"
                            @changeColor="changeBackgroundColor"
                    />
                </div>
            </b-dropdown>
        </b-button-group>
        <b-button-group
                v-click-outside="(e) => toggleCollapse(e,true)"
        >
            <b-button
                    @click="(e) => toggleCollapse(e)"
                    variant="outline-primary"
                    class="icon-btn"
            >
                <icon-base
                        :icon-name="'border-all-small'"
                        width="18"
                        height="18"
                        style="margin-bottom: -4px"
                />
            </b-button>
            <b-collapse id="border-picker" class="mt-1" @show="borderCollapse.main = true" @hide="borderCollapse.main = false">
                <div class="flex-container flex-column d-flex py-2 px-2">
                    <div class="d-flex">
                        <div
                                class="flex-item"
                                v-for="border in this.borders"
                                :key="border.type"
                                @click.prevent="borderTypeClick(border)"
                        >
                            <icon-base
                                    style="margin-bottom: 0;"
                                    :icon-name="border.icon"
                                    width="24"
                                    height="24"
                            />
                        </div>
                    </div>
                    <div
                            class="d-flex my-2"
                            style="border-top: 2px solid lightgray;"
                    ></div>
                    <div class="d-flex">
                        <div class="flex-fill action-container">
                            <div class="flex-action" v-b-toggle.line-weight>
                                <icon-base
                                        style="margin-bottom: 0;"
                                        icon-name="line-weight"
                                        width="18"
                                        height="18"
                                />
                                <font-awesome-icon :icon="['fas', 'caret-down']" size="xs" />
                            </div>
                            <b-collapse id="line-weight" @show="borderCollapse.width = true" @hide="borderCollapse.width = false">
                                <div class="flex-container d-flex flex-column py-2">
                                    <div
                                            v-for="(size, index) in this.borderWidth"
                                            :key="`size-${index}`"
                                            class="border-width-item my-1 p-2"
                                            :class="{ active: size.state }"
                                            @click="borderWidthClick(size)"
                                    >
                                        <div
                                                class="line-display"
                                                :style="{ height: size.value }"
                                        ></div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                        <div style="border-right: 1px solid lightgray;"></div>
                        <div class="flex-fill action-container">
                            <div class="flex-action" v-b-toggle.border-color>
                                <icon-base
                                        style="margin-bottom: 0;"
                                        icon-name="border-color"
                                        width="18"
                                        height="18"
                                />
                                <font-awesome-icon :icon="['fas', 'caret-down']" size="xs" />
                            </div>
                            <b-collapse id="border-color" @show="borderCollapse.color = true" @hide="borderCollapse.color = false">
                                <div class="flex-container d-flex flex-column py-2">
                                    <div class="color-picker">
                                        <color-picker
                                                theme="light"
                                                v-if="showBorderColorPicker"
                                                :sucker-hide="true"
                                                :color="borderColor"
                                                :colors-history-key="colorsHistoryKey"
                                                :colors-default="societyColors"
                                                @changeColor="changeBorderColor"
                                        />
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </b-button-group>
        <b-button-group>
            <b-button
                    v-for="align in this.textAlign"
                    :key="align.type"
                    @click.prevent="textAlignClick(align.type)"
                    :pressed="align.state"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', align.icon]" />
            </b-button>
        </b-button-group>
        <b-button-group>
            <b-button
                    v-for="align in this.textVAlign"
                    :key="align.type"
                    @click.prevent="textVAlignClick(align.type)"
                    :pressed="align.state"
                    class="custom-icon-btn "
                    variant="outline-primary"
            >
                <icon-base
                        style="margin-bottom: -8px;padding-left: 2px; padding-right: 2px;"
                        :icon-name="align.icon"
                        width="24"
                        height="24"
                />
            </b-button>
        </b-button-group>
        <b-button-group>
            <b-button
                    :pressed="this.whiteSpace.state"
                    @click.prevent="textWrapClick()"
                    class="icon-btn icon-wrap-custom"
                    variant="outline-primary"
                    style=" line-height: 0; padding-right:0;"
            >
                <icon-base
                        style="margin-bottom: -8px;"
                        icon-name="textWrap"
                        width="22"
                        height="22"
                />
            </b-button>
        </b-button-group>
        <div class="divider"></div>
        <b-button-group>
            <b-button
                    @click.prevent="removeStyle()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <icon-base
                        style="margin-bottom: -4px;"
                        icon-name="format-clear"
                        width="18"
                        height="18"
                />
            </b-button>
        </b-button-group>
        <div class="divider"></div>
        <b-button-group>
            <b-button
                    @click.prevent="createSet()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <font-awesome-icon :icon="['fas', 'plus']" /> Créer un ensemble
            </b-button>
        </b-button-group>
        <b-button-group>
            <b-button
                    @click.prevent="removeFromSet()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                Retirer de l'ensemble
            </b-button>
        </b-button-group>
        <div class="divider"></div>
        <b-button-group>
            <b-button
                    @click.prevent="configFormatDonnees()"
                    class="icon-btn"
                    variant="outline-primary"
            >
                <icon-base
                        style="margin-bottom: -8px;"
                        icon-name="column"
                        width="24"
                        height="24"
                />
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { fontSizes } from '../../config/constanteUse'
import { removeHtmlTag } from '../../utils/util'
import colorPicker from '@caohenghu/vue-colorpicker'
import iconBase from '../icons/iconBase'
import vClickOutside from 'v-click-outside'
import axios from 'axios'
import { ENTRYPOINT } from '../../config/entrypoint'

export default {
  components: {
    colorPicker,
    iconBase
  },
  props: {
    currentCell: undefined
  },
  computed: {
    isSelectingColor () {
      return this.showFontColorPicker || this.showBackgroundColorPicker || this.showBorderColorPicker
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data () {
    return {
      data: {},
      usedFontColor: null,
      usedBgColor: null,
      usedBorderColor: null,
      colorsHistoryKey: 'font-color-story',
      bgHistoryKey: 'bg-color-story',
      borderHistoryKey: 'border-color-story',

      colorsHistory: [],
      bgHistory: [],
      borderHistory: [],

      societyColors: null,
      borderCollapse: {
        main: false,
        width: false,
        color: false
      },
      borderPickerShown: false,
      context: null,
      textAlign: [
        { icon: 'align-left', type: 'left', state: false },
        { icon: 'align-center', type: 'center', state: false },
        { icon: 'align-right', type: 'right', state: false }
      ],
      textVAlign: [
        { icon: 'align-top', type: 'top', state: false },
        { icon: 'align-middle', type: 'middle', state: false },
        { icon: 'align-bottom', type: 'bottom', state: false }
      ],
      fontStyle: {
        name: 'italic', state: false
      },
      textDecoration: {
        name: 'underline', state: false
      },
      whiteSpace: {
        name: 'pre-wrap', state: false
      },
      fontWeight: {
        name: 'bold', state: false
      },
      fontFamily: [
        { name: 'Arial', family: 'Arial, Helvetica, sans-serif', state: true },
        { name: 'Arial Black', family: '"Arial Black", Gadget, sans-serif', state: false },
        { name: 'Impact', family: 'impactregular', state: false },
        { name: 'Comic Sans MS', family: '"Comic Sans MS", cursive, sans-serif', state: false },
        { name: 'Courier New', family: '"Courier New", Courier, monospace', state: false },
        { name: 'Georgia', family: 'Georgia, serif', state: false },
        { name: 'Lucida Console', family: '"Lucida Console", Monaco, monospace', state: false },
        { name: 'Lucida Sans Unicode', family: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', state: false },
        { name: 'Open Sans', family: '"Open sans", Arial, sans-serif', state: false },
        { name: 'Palatino Linotype', family: '"Palatino Linotype", "Book Antiqua", Palatino, serif', state: false },
        { name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif', state: false },
        { name: 'Times New Roman', family: '"Times New Roman", Times, serif', state: false },
        { name: 'Trebuchet MS', family: '"Trebuchet MS", Helvetica, sans-serif', state: false },
        { name: 'Verdana', family: 'Verdana, Geneva, sans-serif', state: false },
        { name: 'Corbel', family: 'Corbel', state: false },
        { name: 'Calibri', family: 'Calibri', state: false },
        { name: 'Lucida Sans', family: 'Lucida Sans', state: false },
        { name: 'Agency FB', family: 'Agency FB', state: false },
        { name: 'Berlin Sans FB', family: 'Berlin Sans FB', state: false },
        { name: 'Book Antiqua', family: 'Book Antiqua', state: false },
        { name: 'Century', family: 'Century', state: false },
        { name: 'Century Gothic', family: 'Century Gothic', state: false },
        { name: 'Bell MT', family: 'Bell MT', state: false },
        { name: 'Franklin Gothic Book', family: 'Franklin Gothic Book', state: false },
        { name: 'Candara', family: 'Candara', state: false },
        { name: 'Bookman Old Style', family: 'Bookman Old Style', state: false },
        { name: 'Impacted', family: 'Impacted', state: false },
        { name: 'Arial Narrow', family: 'Arial Narrow', state: false },
        { name: 'Gill Sans', family: 'Gill Sans', state: false },
        { name: 'Avenir Next LT Pro', family: 'Avenir Next LT Pro', state: false }

      ],
      borders: [
        {
          type: 'none', style: 'solid', icon: 'border-none'
        },
        {
          type: 'top', style: 'solid', icon: 'border-top'
        },
        {
          type: 'right', style: 'solid', icon: 'border-right'
        },
        {
          type: 'bottom', style: 'solid', icon: 'border-bottom'
        },
        {
          type: 'left', style: 'solid', icon: 'border-left'
        },
        {
          type: 'all', style: 'solid', icon: 'border-all'
        },
        {
          type: 'outer', style: 'solid', icon: 'border-outer'
        }
      ],
      borderWidth: [
        {
          value: '0.125rem', state: true
        },
        {
          value: '0.1875rem', state: false
        },
        {
          value: '0.250rem', state: false
        },
        {
          value: '0.3125rem', state: false
        }
      ],
      fontSize: [],
      showFontColorPicker: false,
      showBackgroundColorPicker: false,
      showBorderColorPicker: false,
      color: '',
      backgroundColor: '',
      borderColor: '',
      colorPickerDelay: null
    }
  },
  async created () {
    this.fontSize = fontSizes.map(size => {
      if (size === '11') {
        return {
          value: size,
          state: true
        }
      }
      return {
        value: size,
        state: false
      }
    })
    if (!this.currentBorderWidth()) {
      this.setCurrentBorderWidth()
    }
    if (!this.currentBorderColor()) {
      this.setCurrentBorderColor()
    }

    // get font color history
    const userColors = await axios({ url: ENTRYPOINT + '/api/get-user-color-history', method: 'GET' })

    localStorage.setItem(this.colorsHistoryKey, JSON.stringify(userColors.data.font))
    localStorage.setItem(this.bgHistoryKey, JSON.stringify(userColors.data.bg))
    localStorage.setItem(this.borderHistoryKey, JSON.stringify(userColors.data.border))

    this.colorsHistory = userColors.data.font
    this.bgHistory = userColors.data.bg
    this.borderHistory = userColors.data.border

    this.societyColors = userColors.data.societyColors
  },
  mounted () {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      const storeColors = this.$store.state.colors.colors
      const newSocietyColors = [...new Set([...storeColors, ...this.societyColors])]

      this.societyColors = newSocietyColors
      if (this.colorsHistory && this.colorsHistory.length > 0 && this.color === '') {
        this.usedFontColor = this.colorsHistory[0]
        this.color = this.colorsHistory[0]
        this.backgroundColor = this.colorsHistory[0]
      }

      if (bvEvent.vueTarget.id === 'font-color-picker') {
        this.showFontColorPicker = true
      } else if (bvEvent.vueTarget.id === 'background-color-picker') {
        this.showBackgroundColorPicker = true
      }

      localStorage.setItem(this.colorsHistoryKey, JSON.stringify(this.colorsHistory))
    })

    var $this = this

    this.$root.$on('bv::dropdown::hidden', function (bvEvent) {

    })

    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.vueTarget.id === 'font-color-picker') {
        this.showFontColorPicker = false
      } else if (bvEvent.vueTarget.id === 'background-color-picker') {
        this.showBackgroundColorPicker = false
      }

      var payload = {
        color: this.usedFontColor,
        type: 'font'
      }

      if (this.usedFontColor) {
        $this.setUserColor(payload)
      }
    })
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'border-color') {
        this.showBorderColorPicker = isJustShown
      }
    })
  },
  filters: {
    truncate: function (text, length) {
      return (text.length > length) ? text.substring(0, length) + ' ...' : text
    }
  },
  methods: {
    ...mapActions(['updateSelectedCellsBorder', 'updateSelectedCellsStyle', 'setSelectedHeaderData', 'updateSelectedCellValue', 'saveTableauSurface', 'removeSelectedCellsStyle', 'setShowType', 'setCurrentBorderWidth', 'setCurrentBorderColor', 'setIsCloningFormat', 'setIsSelectingColor']),
    ...mapGetters(['showType', 'saving', 'currentBorderWidth', 'currentBorderColor', 'isCloningFormat']),
    async setUserColor (payload) {
      if (payload.color) {
        const resp = await axios({ url: ENTRYPOINT + '/api/set-user-color', data: payload, method: 'POST' })

        this.colorsHistory = resp.data.font
        this.bgHistory = resp.data.bg
        this.borderHistory = resp.data.border
        this.usedFontColor = null
        localStorage.setItem(this.colorsHistoryKey, JSON.stringify(resp.data.font))
      }
    },
    toggleCollapse (e, outside = false) {
      if (outside === true && this.borderCollapse.main) {
        this.toggleCollapse()

        // Set the chosen color
        var color = this.usedFontColor
        var payload = {
          color: this.usedFontColor,
          type: 'font'
        }

        this.setUserColor(payload)

        return
      } else if (outside === true && !this.borderCollapse.main) {
        localStorage.setItem(this.colorsHistoryKey, JSON.stringify(this.colorsHistory))
        return
      }

      this.$root.$emit('bv::toggle::collapse', 'border-picker')
      if (!this.borderCollapse.main) {
        if (this.borderCollapse.width) {
          this.$root.$emit('bv::toggle::collapse', 'line-weight')
        }
        if (this.borderCollapse.color) {
          this.$root.$emit('bv::toggle::collapse', 'border-color')
        }
      }
    },
    createSet () {
      this.$emit('createSet')
    },
    removeFromSet () {
      this.$emit('removeFromSet')
    },
    formatClone () {
      this.setIsCloningFormat(true)
    },
    getSelectedFontFamily () {
      return this.fontFamily.find(el => el.state === true) || this.fontFamily[0]
    },
    getSelectedFontSize () {
      if (this.data && this.data.fontSize) {
        return this.data.fontSize.replace('px', '')
      }
      return '11'
    },
    textAlignClick (type) {
      this.updateStyle('text-align', type)
    },
    textVAlignClick (type) {
      this.updateStyle('vertical-align', type)
    },
    fontSizeSelected (value) {
      this.updateStyle('font-size', value, 'px')
    },
    fontFamilyClick (value) {
      this.updateStyle('font-family', value)
    },
    borderWidthClick (size) {
      this.setCurrentBorderWidth(size.value)
      // this.updateStyle('border-width', size.value)
      this.$root.$emit('bv::toggle::collapse', 'line-weight')
    },
    fontWeightClick () {
      const state = !this.fontWeight.state
      if (state) {
        this.updateStyle('font-weight', 'bold')
      } else {
        this.updateStyle('font-weight', 'normal')
      }
    },
    fontUnderlineClick () {
      const state = !this.textDecoration.state
      if (state) {
        this.updateStyle('text-decoration', 'underline')
      } else {
        this.updateStyle('text-decoration', 'none')
      }
    },
    textWrapClick () {
      const state = !this.whiteSpace.state

      if (state) {
        this.updateStyles('white-space: pre-wrap; overflow-wrap: break-word; word-wrap: break-word')
        // this.updateStyle('overflow-wrap', 'break-word')
        // this.updateStyle('word-wrap', 'break-word')
      } else {
        this.updateStyles('white-space: nowrap; overflow-wrap: initial; word-wrap: initial')
        // this.updateStyle('white-space', 'normal')
        // this.updateStyle('overflow-wrap', 'initial')
        // this.updateStyle('word-wrap', 'initial')
      }
    },
    fontStyleClick () {
      const state = !this.fontStyle.state
      if (state) {
        this.updateStyle('font-style', 'italic')
      } else {
        this.updateStyle('font-style', 'normal')
      }
    },
    getSelectionText () {
      let text = ''
      if (window.getSelection) {
        text = window.getSelection().toString()
      } else if (document.selection && document.selection.type !== 'Control') {
        text = document.selection.createRange().text
      }
      return text
    },
    exposantClick () {
      const selected = this.getSelectionText()
      if (selected !== '') {
        if (this.data.hasOwnProperty('valeur')) {
          this.data.valeur = removeHtmlTag(this.data.valeur).replace(selected, `<sup>${selected}</sup>`)
          const { valeur, col, lig } = this.data
          this.updateSelectedCellValue({ valeur, col, lig })
          return
        }
        this.data.titre = removeHtmlTag(this.data.titre).replace(selected, `<sup>${selected}</sup>`)
        const { titre, col, lig } = this.data
        this.updateSelectedCellValue({ titre, col, lig })
      } else {
        if (this.data.hasOwnProperty('valeur')) {
          this.data.valeur = removeHtmlTag(this.data.valeur)
          const { valeur, col, lig } = this.data
          this.updateSelectedCellValue({ valeur, col, lig })
          return
        }
        this.data.titre = removeHtmlTag(this.data.titre)
        const { titre, col, lig } = this.data
        this.updateSelectedCellValue({ titre, col, lig })
      }
    },
    indiceClick () {
      const selected = this.getSelectionText()
      if (selected !== '') {
        if (this.data.hasOwnProperty('valeur')) {
          this.data.valeur = removeHtmlTag(this.data.valeur).replace(selected, `<sub>${selected}</sub>`)
          const { valeur, col, lig } = this.data
          this.updateSelectedCellValue({ valeur, col, lig })
          return
        }
        this.data.titre = removeHtmlTag(this.data.titre).replace(selected, `<sub>${selected}</sub>`)
        const { titre, col, lig } = this.data
        this.updateSelectedCellValue({ titre, col, lig })
      } else {
        if (this.data.hasOwnProperty('valeur')) {
          this.data.valeur = removeHtmlTag(this.data.valeur)
          const { valeur, col, lig } = this.data
          this.updateSelectedCellValue({ valeur, col, lig })
          return
        }
        this.data.titre = removeHtmlTag(this.data.titre)
        const { titre, col, lig } = this.data
        this.updateSelectedCellValue({ titre, col, lig })
      }
    },
    changeColor (color) {
      this.usedFontColor = this.toRgbaString(color)
      this.updateStyle('color', this.toRgbaString(color))
    },
    changeBackgroundColor (backgroundColor) {
      this.usedBgColor = this.toRgbaString(backgroundColor)
      this.usedFontColor = this.toRgbaString(backgroundColor)
      this.updateStyle('background-color', this.toRgbaString(backgroundColor))
    },
    changeBorderColor (borderColor) {
      this.usedBorderColor = this.toRgbaString(borderColor)
      this.usedFontColor = this.toRgbaString(borderColor)
      this.setCurrentBorderColor(this.toRgbaString(borderColor))
      // this.updateStyle('border-color', borderColor.rgba.toRgbaString())
    },
    toRgbaString (color) {
      const { r, g, b, a } = color.rgba
      return `rgba(${r}, ${g}, ${b}, ${a})`
    },
    borderTypeClick (border) {
      // this.updateSelectedCellsBorder(border)
      switch (border.type) {
        case 'top':
          this.updateStyle('border-top', `${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()}`)
          break
        case 'right':
          this.updateStyle('border-right', `${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()}`)
          break
        case 'bottom':
          this.updateStyle('border-bottom', `${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()}`)
          break
        case 'left':
          this.updateStyle('border-left', `${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()}`)
          break
        case 'none':
          this.updateStyles('border-left:;border-right:;border-top:;border-bottom:;')
          break
        case 'all':
          this.updateStyles(`
          border-left: ${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()};
          border-right: ${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()};
          border-top: ${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()};
          border-bottom: ${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()};
          `)
          break
        case 'outer':
          this.updateStyles('border-outer', `${this.currentBorderWidth()} ${border.style} ${this.currentBorderColor()}`)
          break
      }
    },
    updateStyle (attribut, value, unit = '') {
      this.data[this.toCamelCase(attribut)] = `${value}${unit}`
      this.$emit('setStyle', { attribut, value: `${value}${unit}` })
      this.syncStateData(this.data)
    },
    updateStyles (attribut, value = null) {
      var attr = attribut.split(';')

      // Condition below is to allow the update of state for toobar buttons.
      // For some reason, when we apply multiple style, the `pressed` state of the toolbar button doesn't work.
      // This is an attemp to fix this.
      if (attr.length > 0) {
        var splitFirstItem = attr[0].split(':')

        if (splitFirstItem.length > 1) {
          var choseAttribute = splitFirstItem[0].trim()
          var choseValue = splitFirstItem[1].trim()

          this.data[this.toCamelCase(choseAttribute)] = `${choseValue}`
          this.syncStateData(this.data)
        }
      }

      this.$emit('setStyle', { attribut, value })
    },
    toCamelCase (str) {
      const strList = str.split('-')
      if (strList.length > 1) {
        return `${strList[0]}${strList[1].charAt(0).toUpperCase()}${strList[1].slice(1)}`
      }
      return str
    },
    removeStyle () {
      this.$emit('removeStyle')
    },
    syncStateData (newValue) {
      this.data = { ...newValue }
      this.textAlign.forEach(el => {
        if (this.data.textAlign === el.type) {
          el.state = true
          return
        }
        el.state = false
      })
      this.textVAlign.forEach(el => {
        if (this.data.verticalAlign === el.type) {
          el.state = true
          return
        }
        el.state = false
      })
      if (this.data.fontSize) {
        this.fontSize.forEach(el => {
          if (this.data.fontSize.replace('px', '') === el.value) {
            el.state = true
            return
          }
          el.state = false
        })
      }
      if (this.data.fontFamily) {
        this.fontFamily.forEach(el => {
          if (this.data.fontFamily === el.family) {
            el.state = true
            return
          }
          el.state = false
        })
      }
      this.borderWidth.forEach(el => {
        if (this.currentBorderWidth() === el.value) {
          el.state = true
          return
        }
        el.state = false
      })
      this.fontStyle.state = this.data.fontStyle === this.fontStyle.name
      this.fontWeight.state = this.data.fontWeight === this.fontWeight.name
      this.textDecoration.state = this.data.textDecoration === this.textDecoration.name
      this.whiteSpace.state = this.data.whiteSpace === this.whiteSpace.name
      this.color = this.data.color ? this.data.color : '#000' // Here

      this.borderColor = this.currentBorderColor()
      this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '#FFFFFFF'
    },
    async saveChanges () {
      this.$emit('save')
    },
    configFormatDonnees () {
      this.setShowType(!this.showType())
    },
    handleExport () {
      this.$emit('export')
    },
    handleExportDescription () {
      this.$emit('exportDescription')
    },
    undoClick () {
      this.$emit('undo')
    },
    redoClick () {
      this.$emit('redo')
    }
  },
  watch: {
    currentCell (newValue) {
      if (newValue) {
        this.syncStateData(newValue)
      }
    },
    isSelectingColor (val) {
      this.setIsSelectingColor(val)
    }
  }
}
</script>

<style lang="scss" scoped>
    #border-picker {
        position: absolute;
        bottom: 0;
        top: 100%;
        z-index: 999;
        .flex-container {
            box-shadow: 0px 1px 8px 1px rgba(173, 173, 173, 0.66);
            background-color: white;
            border-radius: 3px;
        }
        .flex-item {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            padding: 3px;
            &:hover {
                background-color: #236aa3;
                color: white;
            }
        }
        .flex-item:after {
            content: " ";
            padding-top: 100%;
            display: table;
        }
        .flex-action {
            text-align: center;
            &:hover {
                background-color: #236aa3;
                color: white;
            }
        }
        .border-width-item {
            .line-display {
                width: 80px;
                background-color: black;
            }
            &:hover {
                background-color: rgba(0, 0, 0, 0.1);
            }
            &.active {
                background-color: #236aa3;
                .line-display {
                    background-color: white;
                }
            }
        }
    }
    .action-container {
        position: relative;
        #line-weight {
            margin-left: 5px;
            position: absolute;
            left: 100%;
            top: 0;
            z-index: 999;
        }
        #border-color {
            margin-right: 5px;
            position: absolute;
            right: 100%;
            top: 0;
            z-index: 999;
        }
    }

    .divider {
        border-right: 1px solid #d1e1ef;
        width: 2px;
        margin: 0 5px;
    }
</style>

<style lang="scss">
    .font-type.height-small {
        ul {
            height: auto !important;
        }
    }

    .font-type.heighted {
        ul {
            height: 250px;
            overflow-y: auto;
        }
    }

    .icon-wrap-custom.active path,
    .icon-wrap-custom:hover path {
        fill: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/tableau/toolbar.vue